import { useMutation, useQueryClient } from "@tanstack/react-query"
import { reviseAdminQuotation, type ReviseAdminQuotationPayload } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

interface ReviseArgs {
  id: string
  payload: ReviseAdminQuotationPayload
}

export function useReviseAdminQuotation() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: ReviseArgs) => {
      if (!accessToken) throw new Error("Not authenticated")
      return reviseAdminQuotation(id, payload, accessToken)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["admin-buyer-quotations"] })
    },
  })
}
